import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, Clock, Truck } from 'lucide-react';
const steps = [{
  icon: MousePointerClick,
  title: 'Elige tu desayuno',
  description: 'Revisa nuestras opciones y selecciona la que más te guste para esa persona especial.'
}, {
  icon: Clock,
  title: 'Reserva con anticipación',
  description: 'Contáctanos por WhatsApp con al menos 24 horas de anticipación para preparar todo perfecto.'
}, {
  icon: Truck,
  title: 'Entrega en tu puerta',
  description: 'Llevamos tu sorpresa gratis dentro del radio urbano (hasta Bahía Catalina).'
}];
export function HowItWorks() {
  return <section className="py-24 px-6 bg-white" data-id="element-51">
      <div className="max-w-5xl mx-auto" data-id="element-52">
        <div className="text-center mb-16" data-id="element-53">
          <h2 className="text-4xl font-serif text-brand-dark mb-6" data-id="element-54">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto text-balance" data-id="element-55">
            Sorprende a tus seres queridos con un desayuno especial a domicilio.
            Perfecto para cumpleaños, aniversarios y momentos inolvidables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-56">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="flex flex-col items-center text-center group" data-id="element-57">
              <div className="w-20 h-20 bg-brand-blush rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-58">
                <step.icon className="w-8 h-8 text-brand-rose" data-id="element-59" />
              </div>
              <h3 className="text-xl font-serif font-bold text-stone-800 mb-3" data-id="element-60">
                {step.title}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-61">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}